// extracted by mini-css-extract-plugin
module.exports = {"contactItem":"ContactItem_contactItem__2BoF4","dark":"ContactItem_dark__3TrOX","inactive":"ContactItem_inactive__3A0-m"};